import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeService } from 'app/services/employee.service';
import { DepartmentService } from 'app/services/department.service';
import { InterfaceEmployee } from 'app/models/employee.model';
import { timezone } from 'assets/constants/timezone';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
import { construct } from 'core-js/fn/reflect';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

@Component({
  selector: 'app-add-indicator',
  templateUrl: './add-indicator.component.html',
  styleUrls: ['./add-indicator.component.scss']
})
export class AddIndicatorComponent implements OnInit {

  isSaving = false;
  indicatorForm: FormGroup;
  monthGoal: FormArray;
  employees: InterfaceEmployee[] = [];
  subscriptions: Subscription[] = [];
  userId: string;
  userName: string;
  selectedEmployee: InterfaceEmployee = {};
  @Input() data: any;
  currentYear = dayjs().tz(timezone).year();

  constructor(
    private fb: FormBuilder,
    public ngbActiveModal: NgbActiveModal,
    protected employeeService: EmployeeService,
    protected departmentService: DepartmentService
  ) {
    this.indicatorForm = this.fb.group({
      priority: new FormControl(null, [Validators.required]),
      indicator: new FormControl(null, [Validators.required]),
      monthgoal: this.fb.group({
        Enero: new FormControl(0, [Validators.required]),
        Febrero: new FormControl(0, [Validators.required]),
        Marzo: new FormControl(0, [Validators.required]),
        Abril: new FormControl(0, [Validators.required]),
        Mayo: new FormControl(0, [Validators.required]),
        Junio: new FormControl(0, [Validators.required]),
        Julio: new FormControl(0, [Validators.required]),
        Agosto: new FormControl(0, [Validators.required]),
        Septiembre: new FormControl(0, [Validators.required]),
        Octubre: new FormControl(0, [Validators.required]),
        Noviembre: new FormControl(0, [Validators.required]),
        Diciembre: new FormControl(0, [Validators.required]),
      }),
      type: new FormControl([Validators.required]),
      startsAt: new FormControl(this.currentYear + '-01-01', [Validators.required]),
      endsAt: new FormControl(this.currentYear + '-12-31', [Validators.required]),
      checkType: new FormControl(null, [Validators.required])
    });
    this.userId = localStorage.getItem("userId") || "Not found User";
    this.userName = localStorage.getItem("userName") || "Not found User";
  }

  ngOnInit(): void {
    if (this.data.isUpdate) {
      let dateEnds = new Date(this.data.area.endsAt * 1000);
      let dateStart = new Date(this.data.area.startsAt * 1000);
      this.indicatorForm.controls['priority'].setValue(this.data.area.priority);
      this.indicatorForm.controls['indicator'].setValue(this.data.area.indicator);
      this.indicatorForm.controls['type'].setValue(this.data.area.type);
      this.indicatorForm.controls['startsAt'].setValue((dateStart.getFullYear()) + "-" + (dateStart.getMonth() + 1 > 10 ? dateStart.getMonth() + 1 : "0" + (dateStart.getMonth() + 1)) + "-" + (dateStart.getDate() + 1 > 10 ? dateStart.getDate() : "0" + (dateStart.getDate())));
      this.indicatorForm.controls['endsAt'].setValue((dateEnds.getFullYear()) + "-" + (dateEnds.getMonth() + 1 > 10 ? dateEnds.getMonth() + 1 : "0" + (dateEnds.getMonth() + 1)) + "-" + (dateEnds.getDate() + 1 > 10 ? dateEnds.getDate() : "0" + (dateEnds.getDate())));
      this.indicatorForm.controls['checkType'].setValue(this.data.area.checkType);
      this.indicatorForm.get('monthgoal').get('Enero').setValue(this.data.area.monthgoal.Enero);
      this.indicatorForm.get('monthgoal').get('Febrero').setValue(this.data.area.monthgoal.Febrero);
      this.indicatorForm.get('monthgoal').get('Marzo').setValue(this.data.area.monthgoal.Marzo);
      this.indicatorForm.get('monthgoal').get('Abril').setValue(this.data.area.monthgoal.Abril);
      this.indicatorForm.get('monthgoal').get('Mayo').setValue(this.data.area.monthgoal.Mayo);
      this.indicatorForm.get('monthgoal').get('Junio').setValue(this.data.area.monthgoal.Junio);
      this.indicatorForm.get('monthgoal').get('Julio').setValue(this.data.area.monthgoal.Julio);
      this.indicatorForm.get('monthgoal').get('Agosto').setValue(this.data.area.monthgoal.Agosto);
      this.indicatorForm.get('monthgoal').get('Septiembre').setValue(this.data.area.monthgoal.Septiembre);
      this.indicatorForm.get('monthgoal').get('Octubre').setValue(this.data.area.monthgoal.Octubre);
      this.indicatorForm.get('monthgoal').get('Noviembre').setValue(this.data.area.monthgoal.Noviembre);
      this.indicatorForm.get('monthgoal').get('Diciembre').setValue(this.data.area.monthgoal.Diciembre);
    }
  }

  close(): void {
    this.ngbActiveModal.close();
  }

  save(): void {
    let newIndicator;
    this.isSaving = true;
    if (this.data.isUpdate) {
      newIndicator = {
        ...this.indicatorForm.value,
        id: this.data.area.id,
        createdById: this.userId,
        createdByName: this.userName,
        createdAt: dayjs().tz(timezone).unix(),
        areaId: this.data.area.areaId,
        areaName: this.data.area.areaName,
        departmentId: this.data.area.departmentId,
        departmentName: this.data.area.departmentName,
        results: this.data.area.results,
      };
      newIndicator.startsAt = dayjs(newIndicator.startsAt, "YYYY-MM-DD").tz(timezone).unix();
      newIndicator.endsAt = dayjs(newIndicator.endsAt, "YYYY-MM-DD").tz(timezone).unix();

      this.departmentService.updateIndicator(newIndicator).then((result: any) => {
        this.ngbActiveModal.close({
          result,
          success: true
        });
      }).catch((error: any) => {
        console.error("Error update indicator =>", error);
        this.ngbActiveModal.close({
          error,
          success: false
        });
      });
    } else {
      newIndicator = {
        ...this.indicatorForm.value,
        id: this.departmentService.generateId(),
        createdById: this.userId,
        createdByName: this.userName,
        createdAt: dayjs().tz(timezone).unix(),
        areaId: this.data.area.id,
        areaName: this.data.area.name,
        departmentId: this.data.area.departmentId,
        departmentName: this.data.area.departmentName,
        results: {}
      };
      newIndicator.startsAt = dayjs(newIndicator.startsAt, "YYYY-MM-DD").tz(timezone).unix();
      newIndicator.endsAt = dayjs(newIndicator.endsAt, "YYYY-MM-DD").tz(timezone).unix();

      this.departmentService.createIndicator(newIndicator).then((result: any) => {
        this.ngbActiveModal.close({
          result,
          success: true
        });
      }).catch((error: any) => {
        console.error("Error create indicator =>", error);
        this.ngbActiveModal.close({
          error,
          success: false
        });
      });
    }
  }
}
